const BarChart = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 9H3.45C3.02996 9 2.81994 9 2.65951 9.08175C2.51839 9.15365 2.40365 9.26839 2.33175 9.40951C2.25 9.56994 2.25 9.77996 2.25 10.2V14.55C2.25 14.97 2.25 15.1801 2.33175 15.3405C2.40365 15.4816 2.51839 15.5964 2.65951 15.6683C2.81994 15.75 3.02996 15.75 3.45 15.75H6.75M6.75 15.75H11.25M6.75 15.75L6.75 6.45C6.75 6.02996 6.75 5.81994 6.83175 5.65951C6.90365 5.51839 7.01839 5.40365 7.15951 5.33175C7.31994 5.25 7.52996 5.25 7.95 5.25H10.05C10.47 5.25 10.6801 5.25 10.8405 5.33175C10.9816 5.40365 11.0963 5.51839 11.1683 5.65951C11.25 5.81994 11.25 6.02996 11.25 6.45V15.75M11.25 15.75H14.55C14.97 15.75 15.1801 15.75 15.3405 15.6683C15.4816 15.5964 15.5963 15.4816 15.6683 15.3405C15.75 15.1801 15.75 14.97 15.75 14.55V3.45C15.75 3.02996 15.75 2.81994 15.6683 2.65951C15.5963 2.51839 15.4816 2.40365 15.3405 2.33175C15.1801 2.25 14.97 2.25 14.55 2.25H12.45C12.03 2.25 11.8199 2.25 11.6595 2.33175C11.5184 2.40365 11.4037 2.51839 11.3317 2.65951C11.25 2.81994 11.25 3.02996 11.25 3.45V6"
      stroke="#535862"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BarChart;
